'use client'

import useTranslations from '@snowball-tech/common/hooks/useTranslations'

import { useState } from 'react'

import Plan from './Plan'
import SubscribeForm from './SubscribeForm'

export default function FreePlan() {
  const $t = useTranslations()

  const [isSubmitted, setIsSubmitted] = useState(false)

  return (
    <Plan
      className="bg-decorative-pink-70"
      description={isSubmitted ? undefined : $t.rich('home.plans.free.details')}
      durationTag={$t('home.plans.free.duration')}
      name={$t('home.plans.free.title')}
      prices={{ yearly: 0 }}
      subtitle={$t('home.plans.free.subtitle')}
      oneShot={{ yearly: true }}
    >
      <SubscribeForm
        label={
          isSubmitted ? false : $t('home.plans.free.subscribe.field.label')
        }
        origin="pricing"
        smallLabel={!isSubmitted}
        submittedTitle={$t('subscribe.title.submitted')}
        onSubmit={() => setIsSubmitted(true)}
      />
    </Plan>
  )
}
